import { useParams, Link } from "react-router-dom";
import { ApiRequest } from "GlobalFunctions";
import React, { useEffect, useState } from "react";
import { Avatar, Divider, Pagination } from "@mui/material";
import Box from "elements/Box";
import BlogDetails from "../Blog/BlogDetails";

export default function CompanyDetails(props: any) {
  const { company_id } = useParams();
  const [company, setCompany] = useState<any>({});
  const [blogs, setBlogs] = useState([]);
  const [selectedBlog] = useState<any>(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const loadBlogs = () => {
    if (!company_id) return;
    ApiRequest({
      url: "/blog/globalCompanyList",
      method: "GET",
      query: { company_id, page },
      setResponse: (res: any) => {
        if (res.status === "success") {
          setBlogs(res.list);
          setTotalPages(res.total_pages || 0);
        }
      },
    });
  };

  useEffect(() => {
    if (!company_id) return;
    ApiRequest({
      url: "/companies/details",
      method: "GET",
      query: { company_id },
      setResponse: (res: any) => {
        if (res.status === "success") setCompany(res.data);
      },
    });
    loadBlogs();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company_id, page]);

  if (selectedBlog) {
    return <BlogDetails id={selectedBlog.blog_id} />;
  }

  return (
    <div className="content">
        <div className="company_content">
            <div className="company_details">
            
            {company.logo && <img src={company.logo} alt={company.name} />}
            <div className="company_info">
                <h2>{company.name}</h2>
                <Divider sx={{borderColor: '#ededed'}} />
                <p>{company.description}</p>
            </div>
            </div>

            <Divider sx={{borderColor: '#ededed'}} />

            <div id='company_blog' className="blog_entries">
                {blogs.length > 0 && blogs.map((blog: any, index: number) => (
                    <Box key={index} className='blog_entry'>
                        <a href={`/${blog.alias}`} className="blog_link">
                        {blog.image && <img className="blog_img" src={blog.image} alt={blog.title} />}
                        
                        <div className='short_blog_content'>
                            <div className='blog_entry_header'>
                                
                                    <h2>{blog.title}</h2>
                                
                                <span className="blog_date">{blog.created_at}</span>
                            </div>
                            
                            <div className="short_blog_content_text">
                                <p className="p_short_content" dangerouslySetInnerHTML={{ __html: blog.short_content }}></p>
                                <div className="blog_author">
                                <Link className="blog_author_link" to={`/enfermeras/${blog.user_id}`}>
                                    <span>Por: {blog.author}</span>
                                    <Avatar src={blog.user_image} />
                                </Link>
                                </div>
                            </div>
                        </div>
                        </a>
                    </Box>
                ))}
            </div>
      
            {totalPages > 1 && (
            <div className="pagination_container">
                <Pagination 
                count={totalPages} 
                page={page}  
                onChange={(event, value) => setPage(value)} 
                color="primary"
                style={{"marginTop": "20px","alignSelf": "center"}}
                />
            </div>
            )}
        </div>
    </div>
  );
}
